import React, { Component } from "react";
import AuthService from "../../../../services/login/auth.service";
import Popup from "react-popup";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { separadorPuntoMiles, formatoSeparadorMilesValue, splitImporte, reemplazarPunto } from "../../../generico/utils/FormatoInput";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { ModalPinTransaccional } from "../../../generico/ModalPinTransaccional";
import PrestamoPreaprobadoService from '../../../../services/solicitudes/PrestamoPreaprobadoService';
import { trackPromise } from 'react-promise-tracker';
import PrestamoInmediatoService from "../../../../services/solicitudes/PrestamoInmediatoService";
import history from "../../../pages/login/history";

export default class Paso2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      depositoAporte: "",
      moraAporte: "L",
      moraSolidaridad: "",
      moraAporteConyuge: "",
      moraSolidaridadConyuge: "",
      mostrarObligaciones: false,
      autorizador:'N'
    }
    this.state = this.getInitialState();
    this.autorizador= sessionStorage.getItem("autorizador")
    
    this.tecladoPinRef = React.createRef();
    this.modalCtrlConfirm = React.createRef();

    this.getMora = this.obtenerMoraCompromiso.bind(this)
    const fechaActual = new Date();
    const fechaEn30Dias = new Date();
    fechaEn30Dias.setDate(fechaActual.getDate() + 30);
    const dia = fechaEn30Dias.getDate();
    const mes = fechaEn30Dias.getMonth() + 1;
    const year = fechaEn30Dias.getFullYear();
    this.fechaVencimientoPrimeraCuota = `${dia}/${mes}/${year}`;

  }

  componentDidMount() {
    this.obtenerMoraCompromiso(this);
    console.log("paso 2");
  }

  getInitialState = () => ({
    pin: "",
    cuentasOrigen: [],
    detalleCuotas: [],
    cuentaSeleccionada: undefined,
    cantCuotas: undefined,
    nroCuotas: undefined,
    disabledNext: true,
    disableSgte: true,
    aceptaTerminos: false,
    pinValue: "",
    mostrarMensajeExito: false,
    fechaActual: new Date(),
    datosMora: {
      "depositoAporte": "",
      "moraAporte": "L",
      "moraSolidaridad": "",
      "moraAporteConyuge": "",
      "moraSolidaridadConyuge": ""
    },
    

  })


  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  notifiPopup1 = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              history.push("resumenGeneralSocio");
              window.location.reload();
            },
          },
        ],
      },
    });

  componentDidUpdate(prevProps, prevState) {

    console.log("limite superior", this.props.limiteSuperior);
    console.log("prevState update", prevState);
    console.log("terminos update", this.state.aceptaTerminos);
    console.log("pin update", this.state.pinValue);
    console.log("terminos props", this.props);
    if ((prevState.aceptaTerminos !== this.state.aceptaTerminos || prevState.autorizador !== this.state.autorizador  || prevState.pinValue !== this.state.pinValue)) {

      this.enableNext();

    };


  }


  obtenerMoraCompromiso() {
    trackPromise(
      PrestamoPreaprobadoService.getMoraCompromisoPi(splitImporte(this.props.importe), '731', 'GS')
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {


            //// posee deuda de aporte
            var totalDesembolso = this.props.importe;
            var sumDeuda = jsonData.datos.depositarAporte + jsonData.datos.moraSolidaridad + jsonData.datos.moraAporteConyuge + jsonData.datos.moraSolidaridadConyuge
            if (sumDeuda > 0) {
              totalDesembolso = Number(splitImporte(this.props.importe)) - sumDeuda;

              this.setState({
                depositoAporte: formatoSeparadorMilesValue(jsonData.datos.depositarAporte),
                moraAporte: formatoSeparadorMilesValue(jsonData.datos.moraAporte),
                moraSolidaridad: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridad),
                moraAporteConyuge: formatoSeparadorMilesValue(jsonData.datos.moraAporteConyuge),
                moraSolidaridadConyuge: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridadConyuge)
              });
              if (this.state.depositoAporte > 0 || this.state.moraSolidaridad > 0 || this.state.moraAporteConyuge > 0 || this.state.moraSolidaridadConyuge > 0) {
                this.setState({ mostrarObligaciones: true });
              }

              var _itemsMoraCompromiso = [
                { concepto: "Depósito Aporte / Relación Aporte", valor: formatoSeparadorMilesValue(jsonData.datos.depositarAporte) + " Gs. " },
                { concepto: "Mora Aporte / Relación Aporte", valor: formatoSeparadorMilesValue(jsonData.datos.depositarAporte) + " Gs. " },
                { concepto: "Mora Solidaridad", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridad) + " Gs. " },
                { concepto: "Mora Aporte del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraAporteConyuge) + " Gs. " },
                { concepto: "Mora Solidaridad del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridadConyuge) + " Gs. " },
              ];

            }
            this.setState({
              itemsMoraCompromiso: _itemsMoraCompromiso,
              moraCompromisoTotal: sumDeuda,
              totalDesembolso: totalDesembolso
            });

            var sucursalSelect = this.state.sucursalList.find(x => x.value === this.state.sucursalDesembolso)

            var montoSolicitado = Number(this.state.value).toString();
            var _itemsConfirm = [
              { concepto: "Sucursal del Desembolso", valor: sucursalSelect.label },
              { concepto: "Plazo (meses)", valor: this.state.plazo },
              { concepto: "Monto de Crédito", valor: formatoSeparadorMilesValue(montoSolicitado) + " Gs." },
            ];
            this.setState({ itemsConfirm: _itemsConfirm });
            ///// levanta popup de confirmación de crédito
            this.modalCtrlConfirm.click();
          }
          else {
            Popup.queue(this.notifiPopup1("Error", jsonData.mensajeRetorno));

            return;

          }
        }

        ));
  }

  selectorValue = (ctaFullData, item) => {

    if (item.length === 0) {

      this.setState({ cuentaSeleccionada: item, disabledNext: true });
      return;
    }
    if (this.state.cantCuotas !== undefined)
      this.setState({ cuentaSeleccionada: item, disabledNext: false });
    else
      this.setState({ cuentaSeleccionada: item, disabledNext: true });
    this.props.rptPaso2Cuenta(item)
  };

  handleCheckboxChange = () => {
    this.setState({
      aceptaTerminos: !this.state.aceptaTerminos
    })
    console.log('valor terminos ', this.state.aceptaTerminos);

  };
  handleCheckboxChangeAutorizo = () => {
    this.setState({
      autorizador: !this.state.autorizador
    })
    console.log('valor terminos ', this.state.aceptaTerminos);

  };

  pinValue = (value) => {
    this.setState({
      pinValue: value,
    });
    console.log("pin primera vez", value);
    // this.enableNext();
  };

 enableNext() {
  const { aceptaTerminos, autorizador } = this.state;
  let puedeHabilitar = false;

  if (aceptaTerminos) {
    if (this.autorizador === 'S') {
      puedeHabilitar = autorizador === true;
    } else {
      puedeHabilitar = true;
    }
  }

  this.setState({ disableSgte: !puedeHabilitar });
}


  confirmarPrestamo = () => {
    this.obtenerMoraCompromiso();
    Popup.create({
      title: "Confirmación",
      content: "Tu crédito por Gs." + formatoSeparadorMilesValue(this.props.importe) + "se ha confirmado." + <br /> + "Te esperamos en la Sucursal {this.state.sucursalDesembolsoLabel} para retirarlo.<br/> Recordá traer tu documento de identidad y una copia de tu factura de servicio básico.",
      buttons: {
        right: [
          {
            text: "Cancelar",
            className: "secundary",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Aceptar",
            className: "success",
            action: () => {

              Popup.close();
            },
          },
        ],
      },
    });
    this.setState({ mostrarMensajeExito: true })

  }


  confirmarBtn = (importe, plazo, sucursal) => {
    var _itemsConfirm = [
      { concepto: "Sucursal del Desembolso", valor: "Villa Morra" },
      { concepto: "Plazo (meses)", valor: this.props.plazo },
      { concepto: "Monto de Crédito", valor: formatoSeparadorMilesValue(this.props.importe) + " Gs." },
    ];
    this.setState({ itemsConfirm: _itemsConfirm });

    console.log("abrir modal ");
    this.modalCtrlConfirm.click();


    //this.modalCtrlConfirm.click();
    return;

  }
  handleConfirmar = () => {

    let importe = String(this.props.importe.toString()).replace(/\./g, "");

    if (importe > Number(this.props.limiteSuperior)) {
      Popup.queue(this.notifiPopup("Estimado Socio", "El monto ingresado supera el máximo permitido para el préstamo."));
      return;
    } else {
      window.$("#modal-pin-extracto").modal("show");
    }
  };

  enviarSolicitud = () => {


    //this.modalCtrlConfirm.click();
    this.obtenerMoraCompromiso();

    let importe = String(this.props.importe.toString()).replace(/\./g, "");

    trackPromise(
      PrestamoPreaprobadoService.confirmarSolicitud(importe, this.props.plazo.toString(), null, "GS", this.props.idAhorro)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);


          if (jsonData.codigoRetorno === "0") {
            this.idCredito = jsonData.datos.idCredito;
            this.props.returnPaso2(this.idCredito, jsonData.datos.idSolicitud, this.state.depositoAporte, this.state.moraAporte, this.state.moraSolidaridad, this.state.moraAporteConyuge, this.state.moraSolidaridadConyuge, this.state.mostrarObligaciones, this.state.totalDesembolso);
            this.props.nextStep();
            this.nextStep.click();
            this.modalCtrlExito.click();
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }
        ));
  }

  descargar = async (tipoReporte) => {
    const data = {
      plazo: this.props.plazo,
      importeCuota: this.props.montoCuota,
      ahorroDesembolso: this.props.idAhorro,
      montoSolicitado: Number(reemplazarPunto(this.props.importe)),
      tazaInteres: this.props.interes,
      tipoReporte
    }
    await trackPromise(
      PrestamoInmediatoService.obtenerReporte(data)
        .then((response) => {
          console.log(response);
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };



  render() {
    window.scrollTo(0, 0);
    if (this.state.mostrarMensajeExito) {
      mensajeExito("La operación se realizó correctamente");
    }
    return (

      <div>
        <div className="row">

          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text ">
                      Selección de Préstamo
                    </span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled current">
                <span>
                  <div className="title">
                    <span className="title_text ">
                      Liquidación de Préstamo
                    </span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="row">
              <div className="col-12" style={{ marginBottom: 30 }}>
                <h6>Verificá todos los datos antes de confirmar el desembolso.</h6>
                <br />
                <h6 className="item-vef" style={{ margin: 0 }}>
                  {AuthService.getSocio().nombreCompleto.trim()}
                </h6>
              </div>
            </div>
            <div className="row invoice-info">
              <div className="col-12">
                <div className="table-responsive">

                  <table className="table conf-prest-inm">
                    <tbody>

                      <tr>
                        <th>El monto total que solicitaste es:</th>
                        <td>{this.props.importe}  Gs.</td>
                      </tr>
                      <tr>
                        <th>Cantidad x importe de cuotas (capital + interés):</th>
                        <td>{this.props.plazo + " x " + separadorPuntoMiles(this.props.montoCuota)} Gs.</td>
                      </tr>


                      <tr>
                        <th>Vencimiento de la primera cuota:</th>
                        <td>{this.fechaVencimientoPrimeraCuota}</td>
                      </tr>
                      {this.state.mostrarObligaciones && <p className="titP3">Obligaciones Societarias</p>}

                      {splitImporte(this.state.depositoAporte) > 0 &&
                        <tr className="thSF">
                          <th className="thSF titMora">Deuda Aporte/Relacion Aporte:</th>
                          <td className="thSF">{this.state.depositoAporte} Gs.</td>
                        </tr>
                      }
                      {/* {splitImporte(this.state.moraAporte) > 0 &&
                        <tr>
                          <th>Deuda Aporte:</th>
                          <td className="titMora">{this.state.moraAporte} Gs.</td>
                        </tr>
                      } */}
                      {splitImporte(this.state.moraSolidaridad) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Solidaridad:</th>
                          <td>{this.state.moraSolidaridad} Gs.</td>
                        </tr>
                      }
                      {splitImporte(this.state.moraAporteConyuge) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Aporte Cónyuge:</th>
                          <td>{this.state.moraAporteConyuge} Gs.</td>
                        </tr>
                      }
                      {splitImporte(this.state.moraSolidaridadConyuge) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Solidaridad Cónyuge:</th>
                          <td>{this.state.moraSolidaridadConyuge} Gs.</td>
                        </tr>
                      }
                      <tr>
                        <th>El importe neto a ser desembolsado es:</th>
                        <td>{separadorPuntoMiles(this.state.totalDesembolso)} Gs.</td>
                      </tr>
                      {this.props.cuentaDeposito &&
                        <tr>
                          <th>El monto se te desembolsará a la cuenta:</th>
                          <td>{this.props.cuentaDeposito}</td>
                        </tr>
                      }
                      <tr>
                        <th>Tasa de interés {separadorPuntoMiles(this.props.interes)} % nominal anual <br />
                        </th>

                        <td></td>
                      </tr>
                      <th className="thSF">Sistema de amortización francés</th>


                    </tbody>
                  </table>

                </div>
              </div>
            </div>

          </div>

        </div>


        <hr />
        <div className="col-lg-12 col-md-12">
          <div className="col-12">

            <div className="col-lg-8 col-md-6">

              <input

                type="checkbox"

                checked={this.state.aceptaTerminos}
                onChange={this.handleCheckboxChange}

                id="contrato-aleatorio"

              /> Al marcar, acepto las  <span className="colorVinculo" onClick={() => { this.descargar('CONTRATO') }}> condiciones y el contrato del préstamo</span>
              <br />

            </div>
              {(this.autorizador==='S') && (
             <div className="col-lg-12 col-md-12 pb-2">

              <input

                type="checkbox"

                checked={this.state.autorizador}
                onChange={this.handleCheckboxChangeAutorizo}

                id="autorizador"

              /> Autorizo el descuento de las cuotas del presente crédito de mi salario, conforme a las condiciones de la línea de crédito seleccionada.
              <br />

            </div>
              )}
          </div>
        </div>
        <hr />

        <div className="row">
          <div className="col-md-6">

          </div>
          <div className="col-lg-3 col-md-3 btn-consulta">
            <button className="btn btn-cu-quintary"
              onClick={this.props.previousStep}>
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
            </button>
          </div>
          <div className="col-lg-3 col-md-3">
            <button

              disabled={this.state.disableSgte}
              className="btn btn-cu-primary"
              onClick={this.handleConfirmar}
            >
              Confirmar Préstamo <FontAwesomeIcon icon={faArrowRight} />
            </button>


            <ModalPinTransaccional id="modal-pin-extracto" onSuccess={this.enviarSolicitud} />
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
          </div>
        </div>
        <a
          ref={(a) => (this.modalCtrlConfirm = a)}
          href="#"

          id="modalCtrlConfirm"
          data-toggle="modal"
          data-target="#idModalConfirm"
        ></a>
        <a
          ref={(a) => (this.modalCtrlExito = a)}
          href="#"
          hidden
          id="modalCtrlExito"
          data-toggle="modal"
          data-target="#procesoExitoso"
          data-backdrop="static"
          data-keyboard="false"
        ></a>

      </div>


    );
  }
}
